import nosMarquesSlider from "../components/nos-marques";
import initCategoryIconsSlider from "../components/category-icons";
import initBestSellerSlider from "../components/best-sellers";
import initLeBlogSlider from "../components/le-blog";
import setupHeroSlider from "../components/hero";

nosMarquesSlider();
initCategoryIconsSlider();
initBestSellerSlider();
initLeBlogSlider();
setupHeroSlider();